import Vue from "vue";

import VueCarousel from "vue-carousel";
import ActionDispatcher from "./ActionDispatcher.vue";
import ActionsDropdown from "./ActionsDropdown.vue";
import BigButtons from "./BigButtons.vue";
import ButtonSwitch from "./ButtonSwitch.vue";
import Card from "./Card.vue";
import Checkbox from "./Checkbox.vue";
import Confirmation from "./Confirmation.vue";
import DataTable from "./DataTable.vue";
import DatePicker from "./DatePicker.vue";
import FormGroup from "./FormGroup.vue";
import InputFile from "./InputFile.vue";
import InputImage from "./InputImage.vue";
import InputSearchSelect from "./InputSearchSelect.vue";
import Loading from "./Loading.vue";
import ModalCompleted from "./ModalCompleted.vue";
import ModalIcon from "./ModalIcon.vue";
import Paginator from "./Paginator.vue";
import ResponsiveModal from "./ResponsiveModal.vue";
import SearchFilter from "./SearchFilter.vue";
import Snackbar from "./Snackbar.vue";
import TagInput from "./TagInput.vue";

import ButtonExport from "./ButtonExport.vue";
import CalendarPicker from "./CalendarPicker.vue";
import CheckboxesDropdown from "./CheckboxesDropdown.vue";
import FilterButton from "./FilterButton.vue";
import Steps from "./Steps.vue";
import StepTitle from "./StepTitle.vue";
import ViewContainer from "./ViewContainer.vue";

import FooterActions from "./FooterActions.vue";
import OverviewCard from "./OverviewCard.vue";
import PageContainer from "./PageContainer.vue";
import PageHeader from "./PageHeader.vue";

Vue.use(VueCarousel);
Vue.component("form-group", FormGroup);
Vue.component("loading", Loading);
Vue.component("snackbar", Snackbar);
Vue.component("action-dispatcher", ActionDispatcher);
Vue.component("confirmation", Confirmation);
Vue.component("search-filter", SearchFilter);
Vue.component("data-table", DataTable);
Vue.component("actions-dropdown", ActionsDropdown);
Vue.component("big-buttons", BigButtons);
Vue.component("tag-input", TagInput);
Vue.component("modal-icon", ModalIcon);
Vue.component("button-switch", ButtonSwitch);
Vue.component("checkbox", Checkbox);
Vue.component("modal-completed", ModalCompleted);
Vue.component("date-picker", DatePicker);
Vue.component("responsive-modal", ResponsiveModal);
Vue.component("card", Card);
Vue.component("paginator", Paginator);
Vue.component("input-search-select", InputSearchSelect);
Vue.component("input-image", InputImage);
Vue.component("input-file", InputFile);

Vue.component("steps", Steps);
Vue.component("step-title", StepTitle);
Vue.component("view-container", ViewContainer);
Vue.component("filter-button", FilterButton);
Vue.component("button-export", ButtonExport);
Vue.component("calendar-picker", CalendarPicker);
Vue.component("checkboxes-dropdown", CheckboxesDropdown);

Vue.component("page-header", PageHeader);
Vue.component("page-container", PageContainer);
Vue.component("footer-actions", FooterActions);
Vue.component("overview-card", OverviewCard);

export { ViewContainer };
